$('.select-all').on('change', function() {
    var checked = this.checked;
    $(this).parents('li').first().find("input").each(function(){
        this.checked = checked;
    })
});